import React from 'react';
import { gql } from '@reverbdotcom/commons/src/gql';
import CoreLink from '@reverbdotcom/commons/src/components/core_link';
import { Listing, core_apimessages_Listing_SeedType as SeedType } from '@reverbdotcom/commons/src/gql/graphql';
import I18n from 'i18n-js';
import { Paths } from '../shared/url_helpers';
import { ArrowRightIcon } from '@reverbdotcom/cadence/icons/react';

interface IExternalProps {
  listing: Listing;
}

export const SellerListingCardTradeInFragment = gql(`
  fragment SellerListingCardTradeInFooter on Listing {
    _id
    id
    tradeInEligibility {
      isEligible
    }
    csp {
      _id
      id
    }
  }
`);

export default function SellerListingCardTradeInFooter({ listing }: IExternalProps) {
  if (!listing.tradeInEligibility.isEligible || !listing.csp?.id) {
    return null;
  }

  const tradeInPath = Paths.sellerTradeIn.expand({
    seed_id: listing.id,
    seed_type: SeedType.Product,
  });

  return (
    <CoreLink to={tradeInPath}>
      <div className="seller-listing-card-trade-in-footer">
        {I18n.t('discovery.tradeIn.sellerListingCardCallout')}
        <span className="seller-listing-card-trade-in-footer__icon">
          <ArrowRightIcon />
        </span>
      </div>
    </CoreLink>
  );
}
